import React from 'react';
import classnames from 'classnames';
import { useQuery } from '@apollo/react-hooks';
import { GetUserQuery } from 'services/apollo';

import { UserNav, Loader } from 'components';
import { useProfileDrawerState, useProfileDrawerDispatch } from 'context';

import styles from './ProfileDrawer.module.scss';

export const ProfileDrawer = () => {
  const { open } = useProfileDrawerState();

  const profileDrawerDispatch = useProfileDrawerDispatch();

  const toggleDrawer = React.useCallback(() => {
    profileDrawerDispatch({ type: 'TOGGLE_DRAWER' });
  }, [profileDrawerDispatch]);

  const { error, data } = useQuery(GetUserQuery, {
    fetchPolicy: 'cache-and-network',
  });

  if (data === undefined)
    return (
      <div className={classnames(styles.container)}>
        <Loader />
      </div>
    );

  if (error)
    return (
      <div className={classnames(styles.container)}>
        <Loader color="Red" />
      </div>
    );

  const identity = data.me.userProfile.name || data.me.userProfile.email;

  return (
    <>
      <span className={styles.profileTrigger} onClick={toggleDrawer}>
        <img className={styles.avatar} alt={identity} src={data.me.userProfile.avatarUrl} />
      </span>

      <div className={classnames(styles.overlay, open && styles.open)} onClick={toggleDrawer} />

      <div className={classnames(styles.container, open && styles.openDrawer)}>
        {open && <UserNav onlyDisplayLogout={undefined} type="List" />}
      </div>
    </>
  );
};
